import React from 'react'
import Modal from 'react-bootstrap/Modal'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

const ModalContainer = styled(Modal)`
  //.border-radius-2 div {
  //  border-radius: 0.5em !important;
  //}
`
const ModalHeader = styled(Modal.Header)`
  background: linear-gradient(270deg, #90dc6c 0%, #17bfce 100%);
`
const ModalTitle = styled(Modal.Title)`
  color: #ffffff;
  font-size: 1.25em;
  font-weight: bold;
  line-height: 24px;
  text-align: center;
  margin-left: 34%;
`
const ModalDescription = styled.p`
  color: #000000;
  font-size: 1.438em;
  font-weight: bold;
  text-align: center;
`
const ViewLink = styled(Link)`
  color: #fff;
  font-size: 1em;
  background: rgb(23, 191, 207);
  background: linear-gradient(
    90deg,
    rgba(23, 191, 207, 1) 0%,
    rgba(152, 222, 99, 1) 100%
  );
  border-color: rgb(23, 191, 207);
  :hover {
    color: black;
    border-color: rgb(23, 191, 207);
  }
`

export default function RedeemModal(props) {
  return (
    <ModalContainer {...props} dialogClassName="border-radius-2" centered>
      <ModalHeader closeButton>
        <ModalTitle>Redeem points</ModalTitle>
      </ModalHeader>
      <Modal.Body>
        <Row className="p-3">
          <Col className="col-12 text-center">
            {/* {this.userData.points > 1000 ? (
              <>
                Please contact
                <a href="mailto:support@halaylla.com">support@halaylla.com</a>
                with your email and contact information to redeem your points
              </>
            ) : ( */}
            <ModalDescription>
              Earn more points to be able to redeem your points
            </ModalDescription>
            {/* // )} */}

            <ViewLink to="dashboard/prizes" className="btn btn-sm mt-2">
              View Prizes
            </ViewLink>
          </Col>
        </Row>
      </Modal.Body>
    </ModalContainer>
    // <Modal isOpen={this.state.RedeemCashModal} toggle={this.RedeemCashToggle} className={this.props.className} centered>
    //     <ModalHeader toggle={this.RedeemCashToggle} className="popup_header_background">
    //         <span className="get_more_points_header"> Redeem Points</span>
    //     </ModalHeader>
    //     <ModalBody>
    //         <div className="row p-3">
    //             <div className="col-12 text-center">
    //                 {this.userData.points > 1000 ? <>
    //                         Please contact
    //                         <a href="mailto:support@halaylla.com">support@halaylla.com</a>
    //                         with your email and contact information to redeem your points
    //                     </>
    //                     :
    //                 <p className="redeem_cash_description text-center">Earn more points to be able to redeem your points</p>}

    //                 <Link to='/prizes' className="btn btn-reward btn-sm mt-2" >
    //                     View Prizes
    //                 </Link>
    //             </div>
    //         </div>
    //     </ModalBody>
    // </Modal>
  )
}
